<div class="back">
    <div class="back-image" [style.background-image]="'url(/assets/login/' + img + ')'"></div>

    <div class="container flex flex-column justify-content-center align-items-center">
        <p-card class="shadow" header="">
            <ng-template pTemplate="header">
                <app-logo [paramChave]="paramTokenAcesso" [loadingEmpresa]="loadingEmpresa" [logoBase64]="imagemLogoBase64"></app-logo>
            </ng-template>

            <div class="flex flex-column align-items-center justify-content-center font-bold border-round m-2">
                <div class="field" *ngIf="!paramTokenAcesso">
                    <div class="card flex flex-wrap justify-content-center gap-3">
                        <span class="p-input-icon-left">
                            <i class="pi pi-cog"></i>
                            <input type="text" [(ngModel)]="tokenAcesso" placeholder="Token de acesso" pInputText />
                        </span>
                    </div>
                </div>

                <div class="field" *ngIf="paramTokenAcesso">
                    <div class="card flex flex-wrap justify-content-center gap-3">
                        <span class="p-input-icon-left">
                            <i class="pi pi-envelope"></i>
                            <input type="text" [(ngModel)]="usuario.email" placeholder="E-mail" pInputText (change)="changeEmail()" />
                        </span>
                    </div>
                </div>

                <div class="field" *ngIf="paramTokenAcesso">
                    <p-password placeholder="Senha" [(ngModel)]="usuario.senha" [toggleMask]="true" [feedback]="false"></p-password>
                </div>

                <p class="color-error" *ngIf="usuarioIncorreto">Usuário ou senha inválido!</p>
                <p class="color-error" *ngIf="empresaErro">Empresa não encontrada!</p>

                <div class="field" *ngIf="paramTokenAcesso">
                    <a routerLink="/esqueci-senha">Esqueci minha senha</a>
                </div>
            </div>
            <ng-template pTemplate="footer">
                <div class="flex flex-column align-items-center justify-content-center font-bold border-round m-2">
                    <div class="pb-5">
                        <p-button class="btn-bg-primary" label="Entrar" (click)="logar()" *ngIf="paramTokenAcesso" [loading]="loading"></p-button>
                        <p-button class="btn-bg-primary" label="Continuar" (click)="selecionarCodigoEmpresa()" *ngIf="!paramTokenAcesso" [disabled]="!tokenAcesso" [loading]="loadingEmpresa"></p-button>
                    </div>
                    <div class="field">
                        <a href='https://oticom.com.br/' target="_blank">Conheça o ÓTICOM LAB</a>
                    </div>
                    <div class="field">
                        <a href='https://embrati.inf.br/' target="_blank">Copyright EMBRATI</a>
                    </div>

                    <div class="field" *ngIf="paramTokenAcesso">
                        <i class="pi pi-fw pi-whatsapp"></i>
                        <a href='https://wa.me/55{{telefoneFaleConosco}}' target="_blank">Fale Conosco</a>
                    </div>
                </div>
            </ng-template>
        </p-card>
    </div>
</div>